export const MAX_ROLLING_TITLE_LENGTH = 100;

export enum RollingAction {
  Share = 'Share',
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',

  GoToAdd = 'GoToAdd',
  GoToEdit = 'GoToEdit',
}

export const RollingActionText = {
  [RollingAction.Share]: '공유하기',
  [RollingAction.Create]: '작성',
  [RollingAction.Update]: '수정',
  [RollingAction.Delete]: '삭제',

  [RollingAction.GoToAdd]: '작성',
  [RollingAction.GoToEdit]: '수정',
};

export enum RollingReactionType {
  Favorite = 'Favorite',
  Recommend = 'Recommend',
  Excited = 'Excited',
}
